import { Component } from '@angular/core';
import { ScreenService } from '@core/framework/screen.service';
import {BaseComponent} from "@base/component/BaseComponent";
import {BaseState} from "@base/entities/BaseEntities";
import {ServiceBagService} from "@base/component/ServiceBag";

class State extends BaseState {
}

@Component({
    selector: 'm4u-demo-layout',
    templateUrl: './demo-layout.component.html',
    styleUrls: ['./demo-layout.component.scss']
})
export class DemoLayoutComponent extends BaseComponent<any> {
    
    constructor(A: ServiceBagService, public screen: ScreenService) {
        super(A, 'DemoLayoutComponent', State);
    }
}